import {GROUP_TYPE, CURSOR, getTextColor, GROUP_SECTION_WIDTH, drawRectangle, drawExpansionIcon, getTrimmedText /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class PhaseGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PHASE, data);
	}

	refreshData(updatedPhase) {
		this.data.name = updatedPhase.name;
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType} = this;
		super.draw(x, y, width, height, this);
		const {name, id, faded} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;

		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		const textColor = getTextColor();

		/*const drawGroup = () => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');
			if (data.isInProjectGroup) {
				context.fillStyle = data.projectGroupColor;
			}
			const xOffset = data.isInProjectGroup ? 16 : 10;
			drawRectangle(context, xOffset, -1, width - xOffset, height + 1, {
				borderColor: '#ebebee',
				borderThickness: 1
			});

			drawExpansionIcon(context, 0, 0, width, height, {
				expanded
			});

			context.fillStyle = textColor;
			context.font = '500 12px ' + Util.getFontFamily();
			context.fillText(getTrimmedText(context, name, 190), 24, 22);
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};*/
		const drawGroup = () => {
			if (data.isInProjectGroup) {
				canvasContext.fillStyle = data.projectGroupColor;
			}
			const xOffset = data.isInProjectGroup ? 16 : 10;
			drawRectangle(canvasContext, x + xOffset, y - 1, width - xOffset, height + 1, {
				borderColor: '#ebebee',
				borderThickness: 1,
			});

			drawExpansionIcon(canvasContext, x, y, width, height, {
				expanded,
			});

			canvasContext.fillStyle = `${textColor}${faded ? 'a1' : ''}`;
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			canvasContext.fillText(getTrimmedText(canvasContext, name, 190), x + 24, y + 22);
		};
		drawGroup();
	}
}

export default PhaseGroup;
